import { Box, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { MetricValueDTO } from '@inversor-hub/types';

interface MetricValueProps {
  metric: MetricValueDTO;
  format: (value: number) => string;
  variant?: 'h4' | 'h5' | 'h6' | 'body1';
  color?: string;
  /** Shown when the metric has no value at all. */
  unavailableHint?: string;
  /** Only pass this when the caveat is actionable. */
  attentionHint?: string;
}

export const MetricValue = ({
  metric,
  format,
  variant = 'h4',
  color,
  unavailableHint,
  attentionHint,
}: MetricValueProps) => {
  if (metric.value === null) {
    return (
      <Tooltip
        title={unavailableHint ?? 'No hay datos suficientes para calcular este valor.'}
        arrow
      >
        <Typography
          variant={variant}
          fontWeight={700}
          color="text.disabled"
          sx={{ cursor: 'help' }}
        >
          —
        </Typography>
      </Tooltip>
    );
  }

  const value = (
    <Typography variant={variant} fontWeight={700} color={color}>
      {format(metric.value)}
    </Typography>
  );

  if (!attentionHint) return value;

  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      {value}
      <Tooltip title={attentionHint} arrow>
        <InfoOutlinedIcon fontSize="small" sx={{ color: 'warning.main', cursor: 'help' }} />
      </Tooltip>
    </Box>
  );
};
